// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Mpqm","unreadBadge":"styles_unreadBadge__2uHHY","modalContent":"styles_modalContent__3YacM","modal":"styles_modal__1ZIBj"};